export * from './websql-sql-module';
export * from './indexeddb-key-value-store-persister';
export * from './browser-key-value-persister';



// WEBPACK FOOTER //
// /home/travis/build/Kinvey/js-sdk/src/core/datastore/persisters/browser/index.js